import React from 'react';
import { Logo } from './logo.jsx';
import { CloseButton } from './closeButton.jsx';
import { BackButton } from './backButton.jsx';
import PropTypes from 'prop-types';
import { WrapperHeaderStyled } from './styled.jsx';

const Header = ({ onClickClose = null, logoUrl = null, onClickBack = null }) => {
  const hasBack = typeof onClickBack === 'function';
  const hasClose = typeof onClickClose === 'function';

  return (
    <WrapperHeaderStyled>
      <div>{hasBack && <BackButton onClick={onClickBack} />}</div>
      <div>{logoUrl && <Logo logoPath={logoUrl} />}</div>
      <div>{hasClose && <CloseButton onClick={onClickClose} />}</div>
    </WrapperHeaderStyled>
  );
};

Header.propTypes = {
  /**
   * Event click button close
   */
  onClickClose: PropTypes.func,
  /**
   * Event click button back
   */
  onClickBack: PropTypes.func,
  logoUrl: PropTypes.string
};

export default Header;
